export function getRandomValue(type: "email" | "phone" | "name") {
  const randomEmail = () => {
    const domains = ["example.com", "test.com", "sample.org"];
    const randomString = (length: number) =>
      Math.random()
        .toString(36)
        .substring(2, 2 + length);
    return `${randomString(5)}@${
      domains[Math.floor(Math.random() * domains.length)]
    }`;
  };

  const randomPhone = () => {
    const randomDigits = () => Math.floor(Math.random() * 10);
    return `+${[...Array(13)].map(randomDigits).join("")}`;
  };

  const randomName = () => {
    const names = ["Alice", "Jose", "Carlos", "David", "Eva", "Fran", "Graça"];
    return names[Math.floor(Math.random() * names.length)];
  };

  switch (type) {
    case "email":
      console.log(randomEmail());
      return randomEmail();
    case "phone":
      return randomPhone();
    case "name":
      return randomName();
    default:
      throw new Error("Invalid type");
  }
}
